(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // gentle parallax on the hero print
  var movers = document.querySelectorAll('[data-speed]');
  if (movers.length && !reduce) {
    var ticking = false;
    var update = function () {
      var y = window.scrollY || 0;
      movers.forEach(function (el) {
        el.style.transform = 'translateY(' + Math.round(y * parseFloat(el.dataset.speed || 0)) + 'px)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  // read more
  document.querySelectorAll('.v-readmore').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var label = btn.querySelector('[data-label]');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
      if (label) label.textContent = open ? 'read more' : 'read less';
    });
  });

  // product page
  var pdp = document.querySelector('[data-v-pdp]');
  if (!pdp) return;

  // gallery thumbs
  var thumbs = pdp.querySelectorAll('.v-thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
      pdp.querySelectorAll('[data-pane]').forEach(function (p) {
        p.classList.toggle('is-hidden', p.dataset.pane !== t.dataset.show);
      });
    });
  });

  // variants — prices always come from the shopify variant data on the page
  var vEl = pdp.querySelector('[data-variants]');
  var mEl = pdp.querySelector('[data-money]');
  if (!vEl) return;
  var variants = JSON.parse(vEl.textContent || '[]');
  var moneyFormat = mEl ? JSON.parse(mEl.textContent) : '${{amount}}';
  var idInput = pdp.querySelector('[data-variant-id]');
  var priceEl = pdp.querySelector('[data-price]');
  var addBtn = pdp.querySelector('[data-add]');

  // order pills: sizes smallest → largest, "print only" before "framed"
  pdp.querySelectorAll('.v-pills').forEach(function (box) {
    var pills = Array.prototype.slice.call(box.querySelectorAll('.v-pill'));
    var key = function (p) {
      var v = (p.querySelector('input').value || '').toLowerCase();
      var n = v.match(/\d+(\.\d+)?/);
      if (n) return parseFloat(n[0]);
      return v.indexOf('framed') > -1 ? 2 : 1;
    };
    pills.sort(function (a, b) { return key(a) - key(b); }).forEach(function (p) { box.appendChild(p); });
  });

  var radios = Array.prototype.slice.call(pdp.querySelectorAll('input[data-option]'));
  var norm = function (s) { return String(s == null ? '' : s).trim(); };

  var fmt = function (cents) {
    var n = (cents / 100);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };

  var chosen = function () {
    var c = [];
    radios.forEach(function (i) { if (i.checked) c[parseInt(i.dataset.option, 10) - 1] = norm(i.value); });
    return c;
  };
  var find = function (c) {
    return variants.find(function (v) {
      return v.options.every(function (o, idx) { return c[idx] === undefined || norm(o) === c[idx]; });
    });
  };

  // grey out values that don't exist with the other picks
  var paint = function () {
    var c = chosen();
    radios.forEach(function (i) {
      var idx = parseInt(i.dataset.option, 10) - 1;
      var test = c.slice(); test[idx] = norm(i.value);
      var ok = !!find(test);
      i.closest('.v-pill').classList.toggle('is-off', !ok);
    });
  };

  var apply = function (changed) {
    var c = chosen();
    var match = find(c);
    if (!match && changed) {
      var idx = parseInt(changed.dataset.option, 10) - 1;
      match = variants.find(function (v) { return norm(v.options[idx]) === norm(changed.value) && v.available; }) ||
              variants.find(function (v) { return norm(v.options[idx]) === norm(changed.value); });
      if (match) {
        radios.forEach(function (i) {
          var k = parseInt(i.dataset.option, 10) - 1;
          if (norm(i.value) === norm(match.options[k])) i.checked = true;
        });
      }
    }
    paint();
    if (!match) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'unavailable'; }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = fmt(match.price);
    if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'add to cart' : 'sold out'; }
    if (changed && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  radios.forEach(function (input) {
    input.addEventListener('change', function () { apply(input); });
  });
  apply(null);
})();
